(() => {
  const hero = document.querySelector('.lus-editorial--hero');
  if (!hero) return;
  const announcement = document.querySelector('.announcement-bar-section');
  const header = document.querySelector('.section-header');
  const country = document.querySelector('[data-lus-country-panel]');
  const root = document.documentElement;
  const setHeight = (name, value) => {
    const next = value + 'px';
    if (root.style.getPropertyValue(name) !== next) root.style.setProperty(name, next);
  };
  const refresh = () => document.body.classList.toggle('lus-home-hero-passed', hero.getBoundingClientRect().bottom <= (header?.offsetHeight || 0));
  const measure = () => {
    setHeight('--lus-home-country-height', country?.offsetHeight || 0);
    setHeight('--lus-home-announcement-height', announcement?.offsetHeight || 0);
    setHeight('--lus-home-header-height', header?.offsetHeight || 0);
    if (root.dataset.lusCountryMode === 'international') setHeight('--header-height', header?.offsetHeight || 0);
    refresh();
  };
  measure();
  addEventListener('scroll', refresh, { passive: true });
  addEventListener('resize', measure, { passive: true });
  addEventListener('luscentra:country-ready', measure);
  addEventListener('pageshow', measure);
  document.fonts?.ready.then(measure);
  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(measure);
    for (const element of [announcement, header, country]) if (element) observer.observe(element);
  }
})();
